'use strict';

module.exports = function calcMaxWidth(attr, nodeTheme/*, options*/) {
	const relevantPositions = ['top', 'bottom', 'center'],
		nodeStyleWidth = (attr && attr.style && attr.style.width),
		nodeThemeWidth = (nodeTheme && nodeTheme.text && nodeTheme.text.maxWidth),
		imageCanExpandText = relevantPositions.includes(attr && attr.icon && attr.icon.position),
		textWrappingWidth = nodeStyleWidth || nodeThemeWidth;

	if (imageCanExpandText) {
		return Math.max(attr.icon.width, textWrappingWidth);
	} else {
		return textWrappingWidth;
	}
};
